import React from 'react';

import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Dialog, IconButton, Typography } from '@mui/material';

import { onboardColors } from '../theme/onboardTokens';

const isImageFile = (name: string) => /\.(jpe?g|png|gif|webp)$/i.test(name);

const DocumentPreviewModal = ({
  assetUrl,
  fileName,
  onClose
}: {
  assetUrl: string;
  fileName: string;
  onClose: () => void;
}) => (
  <Dialog
    fullWidth
    open
    maxWidth="lg"
    onClose={onClose}
    PaperProps={{
      sx: {
        borderRadius: '6px',
        height: '90vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }
    }}
  >
    {/* Header */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: '48px',
        pt: '40px',
        pb: '24px',
        flexShrink: 0
      }}
    >
      <Typography
        sx={{
          color: onboardColors.brand.primary,
          fontSize: '24px',
          fontWeight: 700,
          lineHeight: '30px',
          wordBreak: 'break-all'
        }}
      >
        {fileName}
      </Typography>
      <IconButton
        aria-label="Close preview"
        onClick={onClose}
        size="small"
        sx={{
          color: onboardColors.neutral.textPlaceholderLight,
          ml: '16px',
          flexShrink: 0,
          '&:hover': { color: onboardColors.neutral.textBody }
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>

    {/* Document preview area */}
    <Box
      sx={{
        flex: 1,
        mx: '48px',
        mb: '40px',
        backgroundColor: onboardColors.border.divider,
        borderRadius: '4px',
        overflow: 'auto',
        minHeight: 0
      }}
    >
      {isImageFile(fileName) ? (
        <img
          alt={fileName}
          src={assetUrl}
          style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
        />
      ) : (
        <iframe
          sandbox=""
          src={`${assetUrl}#view=FitH&toolbar=0`}
          style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
          title={fileName}
        />
      )}
    </Box>
  </Dialog>
);

export default DocumentPreviewModal;
